import React from 'react'
import { Global, css } from '@emotion/core'
import './index.css'

export default () => (
  <Global
    styles={css`
      body {
        color: #555555;
        padding: 0;
        margin: 0;
        -webkit-font-smoothing: auto;
        font-size: 14px;
        font-family: Inter;
      }

      @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
        body {
          -webkit-font-smoothing: antialiased;
        }
      }

      p {
        padding: 0;
        margin: 0;
      }

      a {
        text-decoration: none;
      }

      img {
        vertical-align: middle;
      }

      * {
        padding: 0;
        margin: 0;
        font-family: Inter;
        box-sizing: border-box;
      }

      select {
        font-family: 'Roboto';
      }

      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    `}
  />
)
